export const IconRandom = (props: any) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.5121 5.83245C10.6286 5.40884 11.2294 5.40884 11.3459 5.83245L12.1411 8.72468L15.0334 9.51995C15.457 9.63643 15.457 10.2372 15.0334 10.3537L12.1411 11.149L11.3459 14.0412C11.2294 14.4648 10.6286 14.4648 10.5121 14.0412L9.71686 11.149L6.82464 10.3537C6.40102 10.2372 6.40102 9.63643 6.82464 9.51995L9.71686 8.72468L10.5121 5.83245Z"
        fill="white"
      />
      <path
        d="M5.0764 3.28463C5.14112 3.04929 5.47488 3.04929 5.53959 3.28463L5.98141 4.89142L7.5882 5.33324C7.82354 5.39795 7.82354 5.73171 7.5882 5.79642L5.98141 6.23824L5.53959 7.84503C5.47488 8.08038 5.14112 8.08038 5.0764 7.84503L4.63458 6.23824L3.0278 5.79642C2.79245 5.73171 2.79245 5.39795 3.0278 5.33324L4.63458 4.89142L5.0764 3.28463Z"
        fill="white"
        fillOpacity="0.7"
      />
    </svg>
  )
}
